// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"J3-z"};